import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Button, Card, CardContent, Stack, TextField, Typography, Alert } from '@mui/material'

export default function TestLoginPage() {
  const [email, setEmail] = useState('admin@test.com')
  const [password, setPassword] = useState('123456')
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  const handleTestLogin = (e: React.FormEvent) => {
    e.preventDefault()
    setMessage('تم تسجيل الدخول بنجاح! جاري التوجه إلى صفحة الاختبار...')
    
    // توجيه مباشر إلى صفحة اختبار المنتجات
    setTimeout(() => {
      navigate('/test-products', { replace: true })
    }, 1000)
  }

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Card sx={{ width: 400 }}>
        <CardContent>
          <Stack spacing={2} component="form" onSubmit={handleTestLogin}>
            <Typography variant="h6" align="center" color="primary">
              🧪 صفحة اختبار Firebase
            </Typography>
            
            <Alert severity="info">
              هذه صفحة اختبار لتجاوز نظام الحماية واختبار Firebase مباشرة
            </Alert>
            
            <TextField 
              label="Email" 
              type="email" 
              value={email} 
              onChange={e => setEmail(e.target.value)} 
              required 
            />
            <TextField 
              label="Password" 
              type="password" 
              value={password} 
              onChange={e => setPassword(e.target.value)} 
              required 
            />
            
            {message && <Alert severity="success">{message}</Alert>}
            
            <Button variant="contained" type="submit" size="large">
              اختبار Firebase
            </Button>
            
            <Button 
              variant="outlined" 
              onClick={() => navigate('/login')}
              size="small"
            >
              العودة لتسجيل الدخول العادي
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  )
}














































